export const API_URL = process.env.REACT_APP_API_URL;
export const DEVELOP_MODE = process.env.REACT_APP_DEVELOP_MODE;

/**
 * Resuelve la URL de una foto: si ya es URL completa (http) se usa tal cual;
 * si no, se construye con el endpoint download2 del backend.
 */
export const getPhotoUrl = (photo) => {
  if (!photo) return null;
  if (typeof photo === "string" && photo.startsWith("http")) return photo;
  return `${API_URL}/download2/${photo}`;
};
